// extracted by mini-css-extract-plugin
export default {"textBlock":"TextBlock_textBlock__ZGS+9","textEditor":"TextBlock_textEditor__UI256","textValue":"TextBlock_textValue__6zv53"};